




import Vue from "vue";
import ContactsSummaryRoleComponentSelector from "./ContactsSummaryRoleComponentSelector.vue";
import { icons } from "@/utils";

export default Vue.extend({
  name: "ContactsMenuList",

  components: {
    ContactsSummaryRoleComponentSelector,
  },

  created() {
    this.$store.commit("header/title", {
      context: this,
      faIcon: icons.contacts,
      text: "Users",
    });
  },
});
